import React, { Component } from "react";
import { compose, withProps } from "recompose";
import Layout from "../../container";
import Router from "next/router";
import { CardList, ItemsList, IconsGrid } from "../../common";
import {
  Card,
  Divider,
  Grid,
  Label,
  Segment,
  Dimmer,
  Loader,
  Item,
  Popup,
  GridRow,
  GridColumn,
  Button,
} from "semantic-ui-react";
import Modal from "react-modal";
import {
  cardData,
  imageData,
  itemData,
  sbody,
  shead,
  tbody,
  thead,
} from "./data.json";
import Head from "next/head";
import {
  addSavedhomes,
  getAllSavedHomelist,
  deleteSavedhomes,
} from "../../modules/Graphql/Savehomegraphql";
import {
  getNHmaphomelist,
  getSchoolinHome,
  getListingsByIds,
  getMlslistings,
  getSlipstreamListings,
  getSlipStreamListngsByIds,
} from "../../modules/Graphql/Nhmaphomegraphql";
import { LandingFooter } from "../../pagecomponents/Welcome";
import { getdetailhomelist } from "../../modules/Graphql/Detailhomegraphql";
import { getNeighborSearch } from "../../modules/Graphql/neighborsearchgraphql";
import {
  getAllneighborboundrieslist,
  getDetailsNhboundrieslist,
} from "../../modules/Graphql/neighborhoodboundriesgraphql";
//import { getAllDetailSchoolList } from '../../modules/Graphql/Detaillistingschoolgraphql';
import {
  addUser,
  updateUser,
  deleteUser,
  getAllUserList,
  getAgents,
} from "../../modules/Graphql/usergraphql";
import millify from "millify";
import Link from "next/link";
import {
  BlackTitle,
  ButtonItem,
  Gallery,
  InText,
  ItemData,
  LabelTag,
  LoginModal,
  SignupModal,
  TableItem,
  Title,
  AmenitiesItem,
  NhGallery,
  StreetView,
  StreetCarousal,
} from "../../components";
import ListingGallery from "./gallery";
// import Gallery from "../Neighborhood/gallery";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";
import Newmap from "./map";
import NeighborMap from "./neighbormap";
// OLD: import { Amplify, Auth } from "aws-amplify";
import { fetchUserAttributes, signOut, signIn } from "aws-amplify/auth";

import CognitoConfig from "../../common/Cognitoconfig";
import {
  get_converted_value,
  customdecodeURIComponent,
  formattedCityName,
} from "../../common/Utils";
import FeedbackForm from "../../common/FeedbackForm";
import AgentContact from "../../components/AgentContact";
// Amplify.configure(CognitoConfig);

var humanFormat = require("human-format");

var imageExists = require("image-exists");
const customStylesSlide = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",
    width: "90%",
    overflow: "hidden",
    margin: "0 auto",
    // border: "none",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.8)",
  },
};
const customStylesStreetModal = {
  content: {
    // top: "50%",
    // left: "50%",
    // right: "auto",
    // bottom: "auto",
    // marginRight: "-50%",
    // transform: "translate(-50%, -50%)",
    width: "90%",
    overflow: "hidden",
    margin: "0 auto",
    // border: "none",
  },
};
class Listing extends React.PureComponent {
  home_id;
  schoolgrades = {
    primaryarr: [
      "K-8",
      "K-12",
      "K-1",
      "K-5",
      "1-12",
      "K",
      "1",
      "K-6",
      "K-2",
      "3-6",
      "1-8",
      "1-6",
      "2-12",
      "K-7",
      "K-3",
      "K-4",
      "1-5",
      "3-5",
      "2-8",
      "3-12",
      "3-8",
      "4-5",
      "K-10",
      "1-10",
      "4",
    ],
    middlearr: [
      "6-12",
      "K-8",
      "6-8",
      "8-12",
      "7-12",
      "K-12",
      "6-7",
      "1-12",
      "7-8",
      "1-8",
      "2-12",
      "K-7",
      "6-9",
      "5-12",
      "5-8",
      "7-10",
      "7",
      "4-12",
      "2-8",
      "8-11",
      "3-12",
      "4-8",
      "3-8",
      "8",
      "K-10",
      "1-10",
      "7-9",
      "5-6",
      "7-11",
      "4-6",
      "6",
    ],
    higharr: [
      "6-12",
      "8-12",
      "7-12",
      "K-12",
      "10-12",
      "1-12",
      "9-12",
      "11-12",
      "12",
      "2-12",
      "5-12",
      "9-10",
      "7-10",
      "4-12",
      "8-11",
      "3-12",
      "9-11",
      "9",
      "K-10",
      "1-10",
      "7-11",
      "10",
    ],
  };
  constructor(props) {
    super(props);
    this.state = {
      loggedin: false,
      save: false,
      lmodal: false,
      smodal: false,
      heart: {},
      activePage: 1,
      activePage1: 1,
      activePage2: 1,
      heading: {
        icon: "home",
        color: "black",
        head: "125 Summerhill Ln",
        subhead: "San Carlos, CA 94060",
        desc: "Status: Active",
        floated: "left",
      },
      more: false,
      userdetails: "",
      email_err_status: false,
      email_err_msg: "",
      pwd_err_status: false,
      pwd_err_msg: "",
      loading: true,
      pagehomedetails: [],
      latitude: "",
      langitude: "",
      neighborname: "",
      npi: "",
      value: 0,
      neighbor_id: "",
      nhfullname: "",
      neighbordatas: [],
      poly_data: [],
      home_data: "",
      home_marker_data: [],
      saved_homeid: "",
      home_address: "",
      getdsaveddata: "",
      savedid: "",
      rightsidehome: "",
      detailschool: [],
      userId: "",
      neighborimage: "",
      schoolistingarr: [],
      school: "",
      safety: "",
      walkability: "",
      townctrscore: "",
      publicscore: 0,
      walkablesteetscore: 0,
      curbappealscore: 0,
      amenitiesscore: 0,
      appreciation: 0,
      personal: "",
      nhprice: 0,
      final_summary: "",
      agent_data: [],
      nhdetails: [],
      isMobile: false,
      sourceType: false,
      is_load_map: false,
      checkimage: "",
      is_from_save: false,
      amenities_factor: [],
      amenitiesFlag: false,
      modalSlider: false,
      modalStreetview: false,
      modalMapview: false,
      selectedItem: 0,
      is_editor: false,
      homeimagesdata: [],
      islistingmodalopen: false,
      is_ratedisplay: false,
      npirank: 0,
      factors: [],
      factors_right: [],
      showAgentPopup: false,
    };
    this.saveHomes = this.saveHomes.bind(this);
    this.get_neighbordetails = this.get_neighbordetails.bind(this);
    this.get_homedetails = this.get_homedetails.bind(this);
    this.get_detailshome = this.get_detailshome.bind(this);
    this.getsavedhomedata = this.getsavedhomedata.bind(this);
    this.getrightsavedhomedata = this.getrightsavedhomedata.bind(this);
    this.getNhDetails = this.getNhDetails.bind(this);
    this.openpopup = this.openpopup.bind(this);
    this.savedrighthome = [];
    this.schoollisting = [];
  }
  getNpiranking = (data) => {
    var getdata = {
      start: 0,
      limit: 300,
      order: "DESC",
      orderBy: "getcityranking",
      fields: [
        {
          name: "postalcity_name",
          value: data[0].postalcity_name,
          operator: "=",
        },
      ],
      userId: "",
    };
    getDetailsNhboundrieslist(getdata)
      .then((result) => {
        if (
          result &&
          result.data.getDetailsNhBoundries &&
          result.data.getDetailsNhBoundries.length > 0
        ) {
          let datanh = result.data.getDetailsNhBoundries;
          let index = datanh.findIndex((datanh) => datanh.id === data[0].id);
          this.setState({ npirank: index + 1 });
        }
      })
      .catch((err) => {});
  };
  get_ranking = (rank) => {
    let ratingval = rank;
    let fullcount = "";
    let quatercount = "";
    let halfcount = "";
    let emptycount = "";
    let quaterhalf = "";

    if (ratingval >= 1 && ratingval <= 1.12) {
      fullcount = 1;
      quatercount = 0;
      halfcount = 0;
      emptycount = 4;
      quaterhalf = 0;
    } else if (ratingval >= 1.13 && ratingval <= 1.37) {
      fullcount = 1;
      quatercount = 1;
      halfcount = 0;
      emptycount = 3;
      quaterhalf = 0;
    } else if (ratingval >= 1.38 && ratingval <= 1.62) {
      fullcount = 1;
      quatercount = 0;
      halfcount = 1;
      emptycount = 3;
      quaterhalf = 0;
    } else if (ratingval >= 1.63 && ratingval <= 1.86) {
      fullcount = 1;
      quatercount = 0;
      halfcount = 0;
      emptycount = 3;
      quaterhalf = 1;
    } else if (ratingval >= 1.87 && ratingval <= 2.12) {
      fullcount = 2;
      quatercount = 0;
      halfcount = 0;
      emptycount = 3;
      quaterhalf = 0;
    } else if (ratingval >= 2.13 && ratingval <= 2.37) {
      fullcount = 2;
      quatercount = 1;
      halfcount = 0;
      emptycount = 2;
      quaterhalf = 0;
    } else if (ratingval >= 2.38 && ratingval <= 2.62) {
      fullcount = 2;
      quatercount = 0;
      halfcount = 1;
      emptycount = 2;
      quaterhalf = 0;
    } else if (ratingval >= 2.63 && ratingval <= 2.86) {
      fullcount = 2;
      quatercount = 0;
      halfcount = 0;
      emptycount = 2;
      quaterhalf = 1;
    } else if (ratingval >= 2.87 && ratingval <= 3.12) {
      fullcount = 3;
      quatercount = 0;
      halfcount = 0;
      emptycount = 2;
      quaterhalf = 0;
    } else if (ratingval >= 3.13 && ratingval <= 3.37) {
      fullcount = 3;
      quatercount = 1;
      halfcount = 0;
      emptycount = 1;
      quaterhalf = 0;
    } else if (ratingval >= 3.38 && ratingval <= 3.62) {
      fullcount = 3;
      quatercount = 0;
      halfcount = 1;
      emptycount = 1;
      quaterhalf = 0;
    } else if (ratingval >= 3.63 && ratingval <= 3.86) {
      fullcount = 3;
      quatercount = 0;
      halfcount = 0;
      emptycount = 1;
      quaterhalf = 1;
    } else if (ratingval >= 3.87 && ratingval <= 4.12) {
      fullcount = 4;
      quatercount = 0;
      halfcount = 0;
      emptycount = 1;
      quaterhalf = 0;
    } else if (ratingval >= 4.13 && ratingval <= 4.37) {
      fullcount = 4;
      quatercount = 1;
      halfcount = 0;
      emptycount = 0;
      quaterhalf = 0;
    } else if (ratingval >= 4.38 && ratingval <= 4.62) {
      fullcount = 4;
      quatercount = 0;
      halfcount = 1;
      emptycount = 0;
      quaterhalf = 0;
    } else if (ratingval >= 4.63 && ratingval <= 4.86) {
      fullcount = 4;
      quatercount = 0;
      halfcount = 0;
      emptycount = 0;
      quaterhalf = 1;
    } else if (ratingval >= 4.87) {
      fullcount = 5;
      quatercount = 0;
      halfcount = 0;
      emptycount = 0;
      quaterhalf = 0;
    }

    return [fullcount, quatercount, halfcount, emptycount, quaterhalf];
  };
  handleWindowSizeChange = () => {
    this.setState({ isMobile: window.innerWidth <= 767 });
  };

  resize = () => this.forceUpdate();

  openAgentPopup = () => {
    this.setState({ showAgentPopup: true });
  };

  closeAgentPopup = () => {
    this.setState({ showAgentPopup: false });
  };

  openpopup = (e, length) => {
    this.setState({ modalSlider: true });
    this.setState({ selectedItem: e });

    setTimeout(() => {
      this.setState({ islistingmodalopen: true });
    }, "500");
  };

  closeModalslider = () => {
    this.setState({ modalSlider: false });
    this.setState({ islistingmodalopen: false });
  };

  openStreetmodal = () => {
    this.setState({ modalStreetview: true });
  };
  closeStreetmodal = () => {
    this.setState({ modalStreetview: false });
  };
  openMapmodal = () => {
    this.setState({ modalMapview: true });
  };
  closeMapmodal = () => {
    this.setState({ modalMapview: false });
  };
  componentDidMount() {
    this.handleWindowSizeChange();

    window.addEventListener("resize", this.handleWindowSizeChange);

    const searchParams = new URLSearchParams(window.location.search);

    this.home_id = searchParams.get("id");
    this.getInitialprechange();
    this.get_homedetails();

    // Auth.currentAuthenticatedUser({
    //   bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    // })
    //   .then((user) => {
    //     const userdetails = Object.values(user.attributes);

    fetchUserAttributes()
      .then((attributes) => {
        const mappedUserDetails = {
          role: attributes["custom:usertype"] || null,
          id: attributes?.sub || null,
          status: attributes?.email_verified === "true" ? true : false,
          first_name: attributes["custom:firstname"] || null,
          s_id: attributes["custom:id"] || null,
          last_name: attributes["custom:lastname"] || null,
          pwd: attributes["custom:confirmpassword"] || null,
          email: attributes.email || null,
        };
        const userdetails = user ? Object.values(mappedUserDetails || {}) : [];

        // if (userdetails[2] === true) {
        if (
          attributes.email_verified === true ||
          attributes.email_verified === "true"
        ) {
          // window.location.href = '/login';
          this.setState({
            userdetails: userdetails,
            loggedin: true,
          });
          /*if(localStorage.saveN)
              {
                  this.setState({
                      save:true
                  })
              }*/
          const getdata = {
            start: 0,
            limit: 10,
            orderBy: "email",
            order: "ASC",
            // fields: [{ name: "email", value: userdetails[7], operator: "=" }],
            fields: [{ name: "email", value: attributes.email, operator: "=" }],
          };
          getAllUserList(getdata)
            .then((result) => {
              result.data.getUser.map((item, index) => {
                this.setState({ userId: item.id });
              });
              //this.getRealortreviewdata();
              // this.gethomessavedbyuser();

              this.getsavedhomedata();
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((err) => {
        if (err) {
          this.setState({
            loggedin: false,
            save: false,
          });
        }
        // window.location.href = '/login'
      });
    localStorage.setItem("previous_url", window.location.href);
  }

  onDisplay = (e, length) => {
    let condition = length - 1;
    let finalcords = this.state.latitude + "," + this.state.langitude;
    condition === e
      ? window.open(`/StreetView/?cordinates=${finalcords}`, "_blank")
      : null;
  };

  // getagents() {
  //   const getdata = {
  //     start: 0,
  //     limit: 10,
  //     orderBy: "'" + this.state.neighbor_id + "'",
  //     order: "DESC",
  //     fields: [
  //       {
  //         name: "neighborhoodid",
  //         value: "'" + this.state.neighbor_id + "'",
  //         operator: "!=",
  //       },
  //     ],
  //   };

  //   getAgents(getdata)
  //     .then((result) => {
  //       let agentitems = [];
  //       result.data.getAgents &&
  //         result.data.getAgents.length > 0 &&
  //         result.data.getAgents.map((item, index) => {
  //           agentitems.push({
  //             id: item.id,
  //             size: "tiny",
  //             image: item.userimage
  //               ? item.userimage
  //               : process.env.NEXT_PUBLIC_CDN_ID +
  //                 "static/images/userdefault.png",
  //             head: item.firstName + " " + item.lastName,
  //             subhead: item.realEstateFirm,
  //             extra: item.points + " Points",
  //             license: item.license ? "CA DRE# " + item.license : "",
  //           });
  //         });

  //       this.setState({ agent_data: agentitems });
  //     })
  //     .catch((err) => {});
  // }

  getschoolinhome = () => {
    let home_id = this.home_id;
    let home_point =
      "POINT(" + this.state.latitude + "," + this.state.langitude + ")";

    const getdata = {
      start: 0,
      limit: 100,
      orderBy: "id",
      order: "ASC",
      fields: [
        {
          name: "id",
          value: home_point,
          operator: "=",
        },
      ],
    };

    getSchoolinHome(getdata)
      .then((result) => {
        let arr = [];

        result.data.getschoolinhome.map((item, index) => {
          let polygoncordinates = item.Boundary[0].split(",");
          let polygoncords_length = polygoncordinates.length;
          if (polygoncords_length > 10) {
            let schooltypes = "";

            if (this.schoolgrades.primaryarr.includes(item.GSserved)) {
              schooltypes = "Primary";
            } else if (this.schoolgrades.middlearr.includes(item.GSserved)) {
              schooltypes = "Middle";
            } else if (this.schoolgrades.higharr.includes(item.GSserved)) {
              schooltypes = "High";
            }

            arr.push({
              school: item.School,
              type: schooltypes,
              grades: item.GSserved,
              //rating: item.GreatSchoolsRating,
              schoolurl: item.greatschoolurl,
              testscorerating: item.TestScores
                ? Number(((item.TestScores / 10) * 5).toFixed(2)).toFixed(1)
                : "",
            });
          }
        });
        let data = arr.sort((a, b) => {
          if (a.type > b.type) return -1;
          if (a.type < b.type) return 1;
          return 0;
        });
        this.schoollisting = data;
        this.setState({ schoolistingarr: data });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  togglePrev = (e, { value }, id) => {
    let condition1 = id.id === "neighborhoods";
    let condition2 = id.id === "agents";
    let condition3 = id.id === "sale";
    condition1
      ? this.setState({ activePage: value.activePage })
      : condition2
        ? this.setState({ activePage1: value.activePage })
        : condition3
          ? this.setState({ activePage2: value.activePage })
          : null;
  };

  modalSubmit = (values) => {
    let id = values.id;

    if (id === "lmodal") {
      const username = values.email;
      const password = values.password;
      var flag = 1;
      if (values && values.email === "") {
        flag = 0;
        this.setState({
          email_err_status: true,
          email_err_msg: "Email is Required",
        });
      }
      if (values && values.password === "") {
        flag = 0;
        this.setState({
          pwd_err_status: true,
          pwd_err_msg: "Password is Required",
        });
      }
      if (flag === 1) {
        this.setState({ isSaving: true });
        // Auth.signIn({
        //   username,
        //   password,
        // })
        signIn({
          username,
          password,
        })
          .then((user) => {
            // Auth.currentAuthenticatedUser({
            //   bypassCache: true, // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            // })
            //   .then((user) => {
            //     const registertype = Object.values(user.attributes);
            fetchUserAttributes()
              .then((attributes) => {
                // if (user.attributes.email_verified === true) {
                if (
                  attributes.email_verified === true ||
                  attributes.email_verified === "true"
                ) {
                  this.setState({ isSaving: false });
                  // if (
                  //   registertype[0] === "homebuyer" ||
                  //   registertype[0] === "webuser"
                  // ) {
                  if (
                    attributes["custom:usertype"] === "homebuyer" ||
                    attributes["custom:usertype"] === "webuser"
                  ) {
                    // window.location.href = '/AcctBuyer'
                    window.location.reload();
                    // } else if (registertype[0] === "realtor") {
                  } else if (attributes["custom:usertype"] === "realtor") {
                    if (item?.realEstateFirm != "") {
                      window.location.reload();
                    } else {
                      window.location.reload();
                    }
                    // } else if (registertype[0] === "neighbor") {
                  } else if (attributes["custom:usertype"] === "neighbor") {
                    window.location.reload();
                  } else {
                    this.setState({
                      verifymessage: "Please verify your email first",
                      pwd_err_msg: "Please verify your email first",
                    });
                  }
                }
              })
              .catch((err) => {});
          })
          .catch((err) => {
            if (err) {
              this.setState({
                message: err.message,
                loggedin: false,
                pwd_err_status: true,
                pwd_err_msg: err.message,
              });
            }
          });
      }
    } else if (id === "smodal") {
      this.setState({ isSaving: true });
      localStorage.setItem("auth_query", JSON.stringify(values));
      localStorage.setItem("previous_url", window.location.href);
      Router.push(
        { pathname: "/RegMain", asPath: "/RegMain", query: values },
        "/RegMain",
      )
        .then(() => {
          this.setState({ isSaving: false });
        })
        .catch(() => {
          this.setState({ isSaving: false });
        });
    }
  };

  onReview = (e) => {
    // alert("calling");
    this.setState({ is_from_nh_review: true });
    const { loggedin } = this.state;
    localStorage.setItem("nhdetails", JSON.stringify(this.state.neighbordatas));
    localStorage.setItem(
      "neighborhoodId",
      this.neighbor_id
        ? this.neighbor_id
        : "60e879f2-b1b0-4ce9-bb26-f06bb9631e98",
    );
    localStorage.removeItem("saveR");
    Router.push("/NHReview").then(() => window.scrollTo(0, 0));
    if (!loggedin) {
      localStorage.setItem("previous_url", window.location.href);
    }
    // const { loggedin } = this.state;
    // if (loggedin) {
    //   localStorage.removeItem("saveR");
    //   localStorage.setItem("nhdetails", JSON.stringify(this.state.nhdetails));
    //   localStorage.setItem(
    //     "neighborhoodId",
    //     this.state.neighbor_id
    //       ? this.state.neighbor_id
    //       : "60e879f2-b1b0-4ce9-bb26-f06bb9631e98",
    //   );
    //   Router.push("/NHReview").then(() => window.scrollTo(0, 0));
    // } else {
    //   localStorage.setItem("saveR", "saveReview");
    //   localStorage.setItem("previous_url", window.location.href);
    //   document.getElementById("sign_up_btn").click();
    // }
  };

  closeModal = () => {
    this.setState({ smodal: false, lmodal: false });
    localStorage.setItem("savehomeid", "");
    this.setState({ is_from_save: false });
  };

  nextModal = (e) => {
    let id = e.target.id;
    id === "smodal"
      ? this.setState({ smodal: false, lmodal: true })
      : this.setState({ smodal: true, lmodal: false });
  };

  onSaveHeart = (data, item) => {
    let { loggedin } = this.state;

    if (loggedin) {
      let { heart } = this.state;
      heart[data] = !heart[data];
      this.setState({ heart });
      if (this.state.heart[data] === true) {
        this.saveHomesRight(item);
        this.forceUpdate();
      } else {
        this.deletesavedright(item);
        this.forceUpdate();
      }
    } else {
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  onGet = (data) => {
    let update = {
      icon: "home",
      color: "black",
      head: data.subhead,
      subhead: data.description,
      desc: "Status: Active",
      floated: "left",
    };
    let heading = this.state;
    this.setState({ heading: update });
  };

  onShow = () => {
    let { more } = this.state;
    this.setState({ more: !more });
  };

  //get saved data
  getsavedhomedata = () => {
    let home_id = this.home_id;
    const getdata = {
      start: 0,
      limit: 100,
      orderBy: "address",
      order: "ASC",
      fields: [
        {
          name: "homeid",
          value: home_id,
          operator: "=",
        },
      ],
    };

    getAllSavedHomelist(getdata)
      .then((result) => {
        this.setState({ getdsaveddata: result.data.getsavedhome });
        this.state.getdsaveddata.map((item, index) => {
          let home_id = this.home_id;

          if (
            item.savedStatus === 1 &&
            item.homeid == home_id &&
            item.userId === this.state.userId
          ) {
            this.setState({
              save: !this.state.save,
            });
            this.setState({
              savedid: item.id,
            });
          }
          // else
          // {
          //   this.setState({
          //     save: false,
          //   })
          // }
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //delete saved data
  deletesaved = () => {
    let home_id = this.home_id;
    const deletedataId = {
      homeid: home_id,
      userId: this.state.userId,
    };
    deleteSavedhomes(deletedataId)
      .then((result) => {})
      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };
  //delete Right saved data
  deletesavedright = (item) => {
    const deletedataId = {
      homeid: item.ListingKeyNumeric,
      userId: this.state.userId,
    };
    deleteSavedhomes(deletedataId)
      .then((result) => {})
      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };
  //add saved home
  saveHomes = () => {
    const adddata = {
      homeid: this.home_id,
      userId: this.state.userId,
      address: this.state.home_address,
      savedDate: new Date(),
      updatedDate: new Date(),
      savedStatus: 1,
      neighborhoodId: this.state.neighbor_id || "",
    };
    addSavedhomes(adddata)
      .then((result) => {})
      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };

  onSaveHome = (e) => {
    let { loggedin } = this.state;
    if (loggedin) {
      localStorage.removeItem("saveN");
      this.setState({ save: !this.state.save });

      if (this.state.save === true) {
        this.deletesaved();
      } else {
        this.saveHomes();
      }
    } else {
      localStorage.setItem("saveN", "saveHome");
      let home_id = this.home_id;
      localStorage.setItem("savehomeid", home_id);
      this.setState({ is_from_save: true });
      localStorage.setItem("previous_url", window.location.href);
      document.getElementById("sign_up_btn").click();
    }
  };

  //get neighbordetails
  getNhDetails = () => {
    let neighborhoodid = "";
    this.state.pagehomedetails.map((item, index) => {
      neighborhoodid = item.neighborhoodId;
    });
    var getdata = {
      start: 0,
      limit: 1,
      order: "DESC",
      orderBy: "id",
      fields: [{ name: "id", value: neighborhoodid, operator: "=" }],
      userId: this.state.userId,
    };

    getDetailsNhboundrieslist(getdata).then((result) => {
      if (result.data.getDetailsNhBoundries) {
        this.setState({
          nhdetails: result.data.getDetailsNhBoundries,
        });
      }
    });
  };
  get_neighbordetails = () => {
    let neighborhoodid = "";
    // this.state.pagehomedetails.map((item, index) => {
    //   neighborhoodid = item.neighborhoodId;
    // });
    let home_point =
      "POINT(" + this.state.latitude + "," + this.state.langitude + ")";

    const getdatanew = {
      start: 0,
      limit: 1,
      orderBy: "name",
      order: "homeinnh",
      fields: [
        {
          name: "id",
          value: home_point,
          operator: "=",
        },
      ],
    };
    getAllneighborboundrieslist(getdatanew)
      .then((result) => {
        if (result.data.getneighborboundries.length > 0) {
          this.setState({ neighbordatas: result.data.getneighborboundries });
          this.getNpiranking(result.data.getneighborboundries);
          result.data.getneighborboundries.map((item, index) => {
            this.setState({ neighbor_id: item.id });
            this.setState({ nhfullname: item.nhfullname });
            this.setState({ neighborname: item.name });
            this.setState({ npi: item.npi });
            this.setState({ value: item.value });
            this.setState({ school: item.school });
            this.setState({ safety: item.crime });
            this.setState({ walkability: item.walkability });
            this.setState({ is_ratedisplay: true });
            this.setState({ walkablesteetscore: item.others });
            this.setState({ nhprice: item.medianprice });
            this.setState({ appreciation: item.appreciation });
            let townctrscore = (item.walkability / 2).toFixed(1);
            let publicscore = item.publicspaces;
            let curbappealscore = item.curb;
            let walkablesteetscore = item.others;

            let amenitiesscore = item.amenities;
            let amenitieslink = "";
            let factors = [];
            let factors_right = [];
            if (amenitiesscore > 0 || amenitiesscore !== "-") {
              amenitieslink = "amenities";
            }
            if (amenitiesscore > 0) {
              amenitiesscore = amenitiesscore;
              this.setState({ amenitiesscore: amenitiesscore });
            } else {
              if (townctrscore > 0) {
                amenitiesscore = townctrscore;
              } else {
                amenitiesscore = "-";
              }
              this.setState({ amenitiesscore: amenitiesscore });
            }
            if (townctrscore > 0) {
              townctrscore = townctrscore;
            } else {
              this.setState({ amenitiesFlag: true });
              townctrscore = "-";
            }
            this.setState({
              townctrscore: townctrscore,
            });
            if (publicscore > 0) {
              publicscore = publicscore;
            } else {
              this.setState({ amenitiesFlag: true });
              publicscore = "-";
            }
            this.setState({ publicscore: publicscore });
            if (curbappealscore > 0) {
              curbappealscore = curbappealscore;
            } else {
              this.setState({ amenitiesFlag: true });
              curbappealscore = "-";
            }
            this.setState({ curbappealscore: curbappealscore });
            // this.getagents();
            let amenities_factor = [];

            let valuescore = 0;
            let valuedata = 0;
            let personalscore = 0;
            let crimescore = 0;
            let schoolscore = 0;
            let walkabilityscore = 0;
            let pricescore = 0;
            let appreciationscore = 0;
            let domscore = 0;

            schoolscore = item.school;
            schoolscore = Number(((schoolscore / 10) * 5).toFixed(2)).toFixed(
              1,
            );

            crimescore = item.crime;
            crimescore = Number(((crimescore / 10) * 5).toFixed(2)).toFixed(1);

            pricescore = item.medianprice;

            if (pricescore && pricescore > 0) {
              pricescore = Math.round(pricescore);
            } else {
              pricescore = "-";
            }

            if (parseInt(item.value) !== 0) {
              valuescore = parseInt(item.value);
            } else {
              valuescore = parseInt(item.valuescore_city);
            }
            if (valuescore) {
              //valuescore = item.value;
              valuescore = "$" + humanFormat(valuescore).replace(/\s/g, "");
              valuescore = valuescore.replace(/-?\d+(\.\d+)?/g, (n) =>
                Number(n).toFixed(0),
              );
              valuescore = valuescore.replace("-", "");
              valuedata = parseInt(item.value);
              //valuescore = Number(((valuescore / 100) * 5).toFixed(2)).toFixed(1);
            } else {
              valuescore = "-";
              valuedata = "-";
            }

            // valuescore = parseInt(item.value);

            // if (valuescore) {
            //   //valuescore = this.state.nhdetails[0].value;
            //   valuescore = "$" + humanFormat(valuescore);
            //   valuescore = valuescore.replace("-", "");
            //   valuedata = parseInt(item.value);
            //   //valuescore = Number(((valuescore / 100) * 5).toFixed(2)).toFixed(1);
            // } else {
            //   valuescore = "-";
            //   valuedata = "-";
            // }

            appreciationscore = item.appreciation;

            if (appreciationscore && appreciationscore !== 0) {
              appreciationscore = Math.round(item.appreciation);
            } else {
              appreciationscore = "-";
            }

            let schoollink = "";
            if (schoolscore > 0) {
              schoollink = "school";
            }
            for (var i = 0; i < 1; i++) {
              factors.push(
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/school-grey.svg",
                  SubContent: schoolscore,
                  tooltiptext: "Neighborhood Weighted Average School Score",
                  medianPriceDomCityFlag: false,
                  appreciationCityFlag: false,
                  amenitiesFlag: false,
                  link: schoollink,
                  title: "School",
                  txtColor: "rgb(15, 20, 67)",
                },
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/safety-grey.svg",
                  SubContent: crimescore,
                  tooltiptext:
                    "Neighborhood Safety Score Ratings from <a href='/' title='Crimeometer'>Crimeometer</a> and Ratings from <a href='#' title='NeighborhoodScout'>NeighborhoodScout</a>",
                  medianPriceDomCityFlag: false,
                  appreciationCityFlag: false,
                  amenitiesFlag: false,
                  link: "safety",
                  title: "Safety",
                  txtColor: "rgb(15, 20, 67)",
                },
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/amenities-grey.svg",
                  SubContent: amenitiesscore,
                  tooltiptext:
                    "Proximity to Merchants Access to Public Spaces Neighborhood Curb Appeal Date from <a href='/' title='Walkscore'>Walkscore</a> and user reviews",
                  medianPriceDomCityFlag: false,
                  appreciationCityFlag: false,
                  amenitiesFlag: this.state.amenitiesFlag,
                  link: amenitieslink,
                  title: "Amenities",
                  txtColor: "rgb(15, 20, 67)",
                },
              );

              factors_right.push(
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/price-grey.svg",
                  SubContent:
                    pricescore !== "-"
                      ? "$" + humanFormat(pricescore).replace(/\s/g, "")
                      : pricescore,
                  tooltiptext: "Neighbrohood weighted median price",
                  medianPriceDomCityFlag: this.state.medianPriceDomCityFlag,
                  appreciationCityFlag: false,
                  amenitiesFlag: false,
                  link: "",
                  isUndervalue: "",
                  title: "Price",
                  txtColor: "rgb(15, 20, 67)",
                },
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/undervalued-grey.svg",
                  SubContent: valuescore,
                  tooltiptext:
                    "Neighborhood Value based on neighborhood factors and price",
                  appreciationCityFlag: this.state.appreciationCityFlag,
                  medianPriceDomCityFlag: false,
                  amenitiesFlag: false,
                  link: "",
                  isUndervalue: valuedata,
                  title:
                    valuedata != "" && valuedata != "-"
                      ? valuedata > 0
                        ? "Overvalued"
                        : "Undervalued"
                      : "Value",
                  txtColor:
                    valuedata && valuedata != "-" && valuedata > 0
                      ? "#c02e26"
                      : "rgb(15, 20, 67)",
                },
                {
                  HeaderImage:
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/factors/appreciation-grey.svg",
                  SubContent:
                    appreciationscore !== "-"
                      ? appreciationscore + "%"
                      : appreciationscore,
                  tooltiptext: "Neighborhood weighted Appreciation",
                  appreciationCityFlag: this.state.appreciationCityFlag,
                  medianPriceDomCityFlag: false,
                  amenitiesFlag: false,
                  link: "",
                  isUndervalue: "",
                  title: "Appreciation",
                  txtColor:
                    appreciationscore == "-" || appreciationscore > 0
                      ? "rgb(15, 20, 67)"
                      : "#c02e26",
                },
              );
            }
            amenities_factor.push(
              {
                icon:
                  process.env.NEXT_PUBLIC_CDN_ID + "static/images/merchant.png",
                title: "Near Good Merchants",
                score: townctrscore > 0 ? townctrscore : "-",
              },
              {
                icon:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/public_space.png",
                title: "Public Spaces",
                score: publicscore > 0 ? publicscore : "-",
              },
              // {
              //   icon:
              //     process.env.NEXT_PUBLIC_CDN_ID +
              //     "static/images/walkable_street.png",
              //   title: "Walkable Streets",
              //   score:
              //     walkablesteetscore > 0
              //       ? walkablesteetscore
              //       : "-",
              // },
              {
                icon:
                  process.env.NEXT_PUBLIC_CDN_ID +
                  "static/images/curb_appeal.png",
                title: "Curb Appeal",
                score: curbappealscore > 0 ? curbappealscore : "-",
              },
            );
            this.setState({
              amenities_factor: amenities_factor,
              factors: factors,
              factors_right: factors_right,
            });
            /* Personal Calculation Start */
            if (
              localStorage.getItem("personal_data") &&
              localStorage.getItem("personal_data") != null
            ) {
              let prsonaldata = JSON.parse(
                localStorage.getItem("personal_data"),
              );

              let schoolsdata = prsonaldata.schoolScore;
              let safetydata = prsonaldata.crimeRate;
              let walkabilitydata = prsonaldata.walkability;
              let publicspacesdata = prsonaldata.publicspaces;
              let curbAppealdata = prsonaldata.curbAppeal;
              let valueindexdata = prsonaldata.valueIndex;
              let minpricedata = prsonaldata.pricemin;
              let maxpricedata = prsonaldata.pricemax;

              var sumOfWeights = 0;

              if (result.data.getneighborboundries[0].school > 0) {
                sumOfWeights += Number(schoolsdata);
              }
              if (result.data.getneighborboundries[0].crime > 0) {
                sumOfWeights += Number(safetydata);
              }
              if (result.data.getneighborboundries[0].walkability > 0) {
                sumOfWeights += Number(walkabilitydata);
              }
              if (result.data.getneighborboundries[0].publicspaces > 0) {
                sumOfWeights += Number(publicspacesdata);
              }
              if (result.data.getneighborboundries[0].curb > 0) {
                sumOfWeights += Number(curbAppealdata);
              }

              var targetFactorWeights = {
                schools: schoolsdata / sumOfWeights,
                safety: safetydata / sumOfWeights,
                walkability: walkabilitydata / sumOfWeights,
                publicspaces: publicspacesdata / sumOfWeights,
                curbAppeal: curbAppealdata / sumOfWeights,
                elementarySchool: 0,
                middleSchool: 0,
                highSchool: 0,
                neighborhoodValueIndexs: valueindexdata / sumOfWeights,
              };

              var targetRadiusFromSearchLocations = 0; // in miles
              var targetSearchLocationLats;
              var targetSearchLocationLongs;
              var targetMinPrices = 0;
              var targetMaxPrices = 0;

              const minPriceAdjustments = 0.85;
              const maxPriceAdjustments = 1.15;
              const minRadiuss = 5.0; // in miles
              const bayAreaNeighborhoodMinimumMedianPrices = 500000.0; // benchmarked to median home price for Antioch
              const maxNviScaleFactors = 0.096;
              if (targetRadiusFromSearchLocations < minRadiuss) {
                targetRadiusFromSearchLocations = minRadiuss;
              }
              targetMinPrices *= minPriceAdjustments;
              targetMaxPrices *= maxPriceAdjustments;

              targetFactorWeights["neighborhoodValueIndexs"] =
                valueindexdata / sumOfWeights;

              targetFactorWeights["schools"] = schoolsdata / sumOfWeights;

              // Copy school weight into elementarySchool, middleSchool, highSchool
              targetFactorWeights["elementarySchool"] =
                targetFactorWeights["schools"];
              targetFactorWeights["middleSchool"] =
                targetFactorWeights["schools"];
              targetFactorWeights["highSchool"] =
                targetFactorWeights["schools"];

              var neighborhoodValueIndexs = 0;

              // neighborhoodValueIndexs =
              //   parseFloat(result.data.getneighborboundries[0].value) / 10;
              neighborhoodValueIndexs = get_converted_value(
                parseFloat(result.data.getneighborboundries[0].value),
              );

              let personalscore =
                parseFloat(
                  parseFloat(result.data.getneighborboundries[0].school) *
                    targetFactorWeights["schools"] +
                    parseFloat(
                      result.data.getneighborboundries[0].publicspaces * 2,
                    ) *
                      targetFactorWeights["publicspaces"] +
                    parseFloat(result.data.getneighborboundries[0].crime) *
                      targetFactorWeights["safety"] +
                    parseFloat(result.data.getneighborboundries[0].curb * 2) *
                      targetFactorWeights["curbAppeal"] +
                    parseFloat(
                      result.data.getneighborboundries[0].walkability,
                    ) *
                      targetFactorWeights["walkability"],
                ) * 10;

              if (!Number.isNaN(personalscore)) {
                personalscore = Number(
                  ((personalscore / 100) * 5).toFixed(2),
                ).toFixed(1);
                this.setState({ personal: personalscore });
              } else {
                personalscore = "-";
              }
            }
            /* Personal Calculation Wrap */

            this.setState({ poly_data: item.geometry_cords[0] }, () => {
              this.get_detailshome_mls();
            });

            if (item.nhsummary && item.length > 0) {
              this.setState({
                final_summary: customdecodeURIComponent(
                  item.nhsummary[0].summary,
                ),
              });
            }
            if (item.neighborhoodImages && item.neighborhoodImages.length > 0) {
              this.setState({
                neighborimage: item.neighborhoodImages[0].imageurl,
              });
            }
          });
          if (
            localStorage.getItem("savehomeid") &&
            localStorage.getItem("savehomeid") !== "" &&
            localStorage.getItem("savehomeid") !== undefined
          ) {
            if (this.home_id === localStorage.getItem("savehomeid")) {
              this.saveHomes();
              this.setState({ save: true });
              localStorage.removeItem("savehomeid");
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //get related homes
  get_detailshome_mls = () => {
    let home_id = this.home_id;
    let default_id = "03592870-9837-4387-a086-b92c43b87c3c";
    this.setState({ saved_homeid: home_id });
    let geo_cords = this.state.poly_data;

    let newdata = JSON.parse(geo_cords);
    let datas = [];
    let reservdedata = newdata.map((item2, index2) => {
      datas.push(item2.y + " " + item2.x);
    });
    let finallatlng = datas.reverse().toString();
    let appdata = { coordinate: finallatlng };
    const getdatanew = {
      appdata,
    };

    //For Database lisiings
    let dbdatas = [];
    let dbreservdedata = newdata.map((item2, index2) => {
      dbdatas.push(item2.x + " " + item2.y);
    });

    let dbfinaldata = dbdatas.toString();

    this.setState({ saved_homeid: home_id });
    const dbgetdatanew = {
      start: 0,
      limit: 1,
      orderBy: "address",
      order: dbfinaldata,
      fields: [
        {
          name: "neighborhoodId",
          value: "",
          operator: "!=",
        },
      ],
    };

    Promise.all([
      getMlslistings(getdatanew),
      getdetailhomelist(dbgetdatanew),
      getSlipstreamListings(getdatanew), // New API added
    ])
      .then((result) => {
        let righthomedata = [];

        // Add MLS Listings if available
        if (
          result[0]?.data?.getMlslistings &&
          Array.isArray(result[0].data.getMlslistings)
        ) {
          righthomedata.push(...result[0].data.getMlslistings);
        }

        // Add Detailed Home Listings if available
        if (
          result[1]?.data?.getdetailhome &&
          Array.isArray(result[1].data.getdetailhome) &&
          result[1].data.getdetailhome.length > 0
        ) {
          righthomedata.push(...result[1].data.getdetailhome);
        }

        // Add Slipstream Listings if available (New API integration)
        if (
          result[2]?.data?.getSlipstreamListings &&
          Array.isArray(result[2].data.getSlipstreamListings)
        ) {
          righthomedata.push(...result[2].data.getSlipstreamListings);
        }

        // Update state with home data
        this.setState({ home_data: righthomedata }, function () {
          if (this.state.loggedin === true) {
            this.getrightsavedhomedata();
          }
        });

        // Prepare marker data
        let markerdata = righthomedata.map((item2) => {
          this.savedrighthome.push(item2.homeid);
          let price;

          if (item2.MlsStatus === "Sold") {
            price = item2.ClosePrice;
          } else {
            if (Number.isInteger(item2.ListPrice)) {
              price = item2.ListPrice;
            }
          }

          return {
            id: item2.ListingKeyNumeric,
            lat: item2.Latitude,
            lang: item2.Longitude,
            price: price,
          };
        });

        // Update state with marker data and map loading state
        this.setState({
          home_marker_data: markerdata,
          is_load_map: true,
        });
      })
      .catch((error) => {
        this.setState({ is_load_map: true });
      });
  };

  get_detailshome = () => {
    let geo_cords = this.state.poly_data[0];

    let newdata = JSON.parse(geo_cords);
    let datas = [];
    let reservdedata = newdata.map((item2, index2) => {
      datas.push(item2.x + " " + item2.y);
    });

    let finaldata = datas.toString();
    let home_id = this.home_id;
    let default_id = "03592870-9837-4387-a086-b92c43b87c3c";
    this.setState({ saved_homeid: home_id });
    const getdatanew = {
      start: 0,
      limit: 1,
      orderBy: "address",
      order: finaldata,
      fields: [
        {
          name: "neighborhoodId",
          value: "",
          operator: "!=",
        },
      ],
    };

    getdetailhomelist(getdatanew)
      .then((result) => {
        this.setState(
          (prevState, props) => ({
            home_data: result.data.getdetailhome,
            ...prevState.items,
          }),
          function () {
            if (this.state.loggedin === true) {
              this.getrightsavedhomedata();
            }
          },
        );
        // {
        //   this.state.home_data.map((item2, index2) => {
        //     this.savedrighthome.push(item2.homeid);
        //   });
        // }
        let markerdata = result.data.getdetailhome.map((item2, index2) => {
          this.savedrighthome.push(item2.homeid);
          let price;
          if (item2.MlsStatus === "Sold") {
            price = item2.ClosePrice;
          } else {
            if (Number.isInteger(item2.ListPrice)) {
              price = item2.ListPrice;
            }
          }
          return {
            id: item2.ListingKeyNumeric,
            lat: parseFloat(item2.Latitude),
            lang: parseFloat(item2.Longitude),
            price: price,
          };
        });
        this.setState({ home_marker_data: markerdata });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  //get homes details
  get_homedetails = () => {
    this.setState({
      loading: true,
    });

    let home_id = this.home_id;
    let default_id = "03592870-9837-4387-a086-b92c43b87c3c";
    const getdatanew = {
      start: 0,
      limit: 1,
      orderBy: "address",
      order: "ASC",
      fields: [
        {
          name: "id",
          value: home_id || default_id,
          operator: "=",
        },
      ],
    };

    const getdatanewmls = {
      ListingKeyNumerics: home_id || default_id,
    };

    let that = this;
    Promise.all([
      getNHmaphomelist(getdatanew),
      getListingsByIds(getdatanewmls),
      getSlipStreamListngsByIds(getdatanewmls), // New API added
    ])
      .then((responses) => {
        let finaldata = [];

        // Check and set NH Map Home Listings
        if (
          responses?.[0]?.data?.getnhmaphome &&
          responses[0].data.getnhmaphome.length > 0
        ) {
          that.setState({ pagehomedetails: responses[0].data.getnhmaphome });
          finaldata = responses[0].data.getnhmaphome;
          that.setState({ sourceType: "SFAR" });
        }
        // Check and set Listings By Ids
        if (
          responses?.[1]?.data?.getListingsByIds &&
          responses[1].data.getListingsByIds.length > 0
        ) {
          that.setState({
            pagehomedetails: responses[1].data.getListingsByIds,
          });
          finaldata = responses[1].data.getListingsByIds;
          that.setState({ sourceType: "MLS Listings" });
        }

        // Check and set SlipStream Listings By Ids (New API integration)
        if (
          responses?.[2]?.data?.getSlipStreamListngsByIds &&
          responses[2].data.getSlipStreamListngsByIds.length > 0
        ) {
          that.setState({
            pagehomedetails: responses[2].data.getSlipStreamListngsByIds,
          });
          finaldata = responses[2].data.getSlipStreamListngsByIds;
          that.setState({ sourceType: "BAY EAST" });
        }

        // Loop through final data and update state/local storage
        finaldata.forEach((item) => {
          that.setState(
            {
              latitude: item.Latitude,
              langitude: item.Longitude,
              home_address: item.UnparsedAddress,
            },
            () => {
              that.get_neighbordetails();
              that.getschoolinhome();
              that.getNhDetails();
            },
          );

          localStorage.setItem("detaillist", false);
          localStorage.setItem("detailnh", true);
          localStorage.setItem("lastvisitednh", "");
          localStorage.setItem(
            "lastvisitedhome",
            item.UnparsedAddress +
              ", " +
              item.City.replace(/([a-z])([A-Z])/g, "$1 $2") +
              ", " +
              item.StateOrProvince +
              ", " +
              item.PostalCode,
          );

          // Fetch additional details
        });
      })
      .catch((error) => {
        console.error("Error fetching home details:", error);
      });

    // getNHmaphomelist(getdatanew)
    //   .then(result => {
    //     if (result.data.getnhmaphome.length === 0) {
    //       this.setState({
    //         loading: false
    //       });
    //     }
    //     if (result.data.getnhmaphome.length > 0) {
    //       this.setState({
    //         loading: false
    //       });

    //       this.setState({ pagehomedetails: result.data.getnhmaphome });
    //       {
    //         this.state.pagehomedetails.map((item, index) => {
    //           this.setState({ latitude: item.Latitude });
    //           this.setState({ langitude: item.Longitude });
    //           //this.setState({ neighbor_id: item.neighborhoodId });
    //           this.setState({ home_address: item.UnparsedAddress });
    //           // this.schoollisting = [
    //           //   {
    //           //     "school": item.elementarySchoolName,
    //           //     "rank": item.elementarySchoolRating
    //           //   },
    //           //   {
    //           //     "school": item.middleSchoolName,
    //           //     "rank": item.middleSchoolRating
    //           //   },
    //           //   {
    //           //     "school": item.highSchoolName,
    //           //     "rank": item.highSchoolRating
    //           //   }
    //           // ]
    //         });
    //       }
    //       this.get_neighbordetails();
    //       this.getschoolinhome();
    //       this.getNhDetails();
    //       //this.get_detailshome();
    //       this.getagents();
    //     } else {
    //       this.get_neighbordetails();
    //       this.getschoolinhome();
    //       this.getNhDetails();
    //       //this.get_detailshome();
    //       this.getagents();
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error);
    //     this.setState({
    //       loading: false
    //     });
    //   });
  };

  //add right side home
  saveHomesRight = (item) => {
    const adddata = {
      homeid: item.ListingKeyNumeric,
      userId: this.state.userId,
      address: item.UnparsedAddress,
      savedDate: new Date(),
      updatedDate: new Date(),
      savedStatus: 1,
      neighborhoodId: this.state.neighbor_id || "",
    };
    addSavedhomes(adddata)
      .then((result) => {})
      .catch((error) => {
        console.error("graphql error:::", error);
      });
  };

  //Get Right Side home
  getrightsavedhomedata = () => {
    const getdata = {
      start: 0,
      limit: 100,
      orderBy: "address",
      order: "ASC",
      fields: [
        {
          name: "userId",
          value: this.state.userId,
          operator: "=",
        },
      ],
    };

    getAllSavedHomelist(getdata)
      .then((result) => {
        result.data.getsavedhome.map((item, index) => {
          if (item.userId === this.state.userId) {
            let { heart } = this.state;
            heart[item.homeid] = true;
            this.setState({ heart });
          } else {
            let { heart } = this.state;
            heart[item.homeid] = false;
            this.setState({ heart });
          }
        });
        this.forceUpdate();
      })
      .catch((error) => {
        console.error(error);
      });
    // const getdata = {
    //   start: 0,
    //   limit: 100,
    //   orderBy: "address",
    //   order: "ASC",
    //   fields: [
    //     {
    //       name: "homeid",
    //       value: "",
    //       operator: "!="
    //     }
    //   ]
    // };

    // getAllSavedHomelist(getdata)
    //   .then(result => {
    //     this.setState({ rightsidehome: result.data.getsavedhome });

    //     {
    //       result.data.getsavedhome.map((item, index) => {
    //         if (item.userId === this.state.userId) {
    //           if (this.savedrighthome.includes(parseInt(item.homeid.trim()))) {
    //             let { heart } = this.state;
    //             heart[item.homeid] = true;
    //             this.setState({ heart });
    //           } else {
    //             let { heart } = this.state;
    //             heart[item.homeid] = false;
    //             this.setState({ heart });
    //           }
    //         }
    //       });
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
  };

  getInitialprechange = () => {
    if (localStorage.getItem("globaluserid")) {
      const getdatanew = {
        start: 0,
        limit: 1,
        orderBy: localStorage.getItem("globaluserid"),
        order: "ASC",
        fields: [
          {
            name: "userId",
            value: localStorage.getItem("globaluserid"),
            operator: "=",
          },
        ],
      };

      getNeighborSearch(getdatanew)
        .then((result) => {
          result.data.getneighborsearch &&
            result.data.getneighborsearch.length > 0 &&
            result.data.getneighborsearch.map((item, index) => {
              const per_data = {
                userId: this.state.userId,
                schoolScore: item.schoolScore,
                crimeRate: item.crimeRate,
                walkability: item.walkability,
                towncenter: item.towncenter,
                curbAppeal: item.curbAppeal,
                publicspaces: item.publicspaces,
                valueIndex: item.valueIndex,
                pricemax: item.pricemax,
                pricemin: item.pricemin,
              };
              localStorage.setItem("personal_data", JSON.stringify(per_data));
            });
          if (
            result.data.getneighborsearch &&
            result.data.getneighborsearch.length === 0
          ) {
            const per_data = {
              userId: this.state.userId,
              schoolScore: 10,
              crimeRate: 10,
              walkability: 10,
              towncenter: 0,
              curbAppeal: 0,
              publicspaces: 0,
              valueIndex: 10,
              pricemax: 0,
              pricemin: 0,
            };
            localStorage.setItem("personal_data", JSON.stringify(per_data));
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      const per_data = {
        userId: this.state.userId,
        schoolScore: 10,
        crimeRate: 10,
        walkability: 10,
        towncenter: 0,
        curbAppeal: 0,
        publicspaces: 0,
        valueIndex: 10,
        pricemax: 0,
        pricemin: 0,
      };
      localStorage.setItem("personal_data", JSON.stringify(per_data));
    }
  };
  checkIfImageExists = (url) => {
    let finaloutput;
    let that = this;
    imageExists(url, function (exists) {
      if (exists) {
        that.setState({ checkimage: url });
        finaloutput = true;
      } else {
        that.setState({ checkimage: url });
        finaloutput = false;
      }
    });
    return finaloutput;
  };

  render() {
    let limit = 530;
    let {
      save,
      lmodal,
      smodal,
      heart,
      activePage,
      activePage1,
      activePage2,
      heading,
      more,
      isMobile,
    } = this.state;
    const [fullcount, quatercount, halfcount, emptycount, quaterhalf] =
      this.get_ranking(
        Number(((this.state.npi / 100) * 5).toFixed(2)).toFixed(1),
      );
    const home = this.state.pagehomedetails?.[0];
    if (!home) return null;

    const {
      UnparsedAddress,
      City,
      StateOrProvince,
      PostalCode,
      BedroomsTotal,
      BathroomsTotalInteger,
      LivingArea,
      YearBuilt,
      LotSizeArea,
      ThumbnailUrl,
      PublicRemarks,
      ListingId,
    } = home;

    // ✅ Combine full address
    const fullAddress = `${UnparsedAddress}, ${City}, ${StateOrProvince}`;
    const slug = `${ListingId}-${UnparsedAddress?.toLowerCase()?.replace(/\s+/g, "-")}-${City?.toLowerCase()}`;
    const url = `https://www.houseberry.com/Listing/${slug}`;

    const title = `${fullAddress} | Houseberry`;
    const description = `Explore ${fullAddress} — a ${BedroomsTotal} bed, ${
      BathroomsTotalInteger ?? "N/A"
    } bath home with ${LivingArea} SqFt. Built in ${YearBuilt}. View photos, nearby schools, and neighborhood data on Houseberry.`;

    // ✅ Structured data (JSON-LD)
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: fullAddress,
      description: `${BedroomsTotal} bed, ${BathroomsTotalInteger ?? "N/A"} bath home built in ${YearBuilt}, featuring ${LivingArea} SqFt.`,
      image: [ThumbnailUrl],
      brand: { "@type": "Organization", name: "Houseberry" },
      url,
      additionalProperty: [
        { "@type": "PropertyValue", name: "Bedrooms", value: BedroomsTotal },
        {
          "@type": "PropertyValue",
          name: "Bathrooms",
          value: BathroomsTotalInteger,
        },
        { "@type": "PropertyValue", name: "Square Feet", value: LivingArea },
        { "@type": "PropertyValue", name: "Lot Size", value: LotSizeArea },
        { "@type": "PropertyValue", name: "Year Built", value: YearBuilt },
      ],
    };

    return (
      <div>
        <Head>
          <link
            rel="stylesheet"
            type="text/css"
            //charset="UTF-8"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
          />
          <link
            rel="stylesheet"
            type="text/css"
            href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
          />

          <link
            rel="stylesheet"
            href="https://unpkg.com/react-rangeslider/umd/rangeslider.min.css"
          />
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={url} />

          {/* OPEN GRAPH */}
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={ThumbnailUrl} />
          <meta property="og:url" content={url} />
          <meta property="og:type" content="article" />
          <meta property="og:site_name" content="Houseberry" />

          {/* TWITTER CARD */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={ThumbnailUrl} />

          {/* STRUCTURED DATA */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
          />
        </Head>
        {/* <Dimmer inverted={false} active={this.state.loading}>
          <Loader size='mini'>Loading</Loader>
        </Dimmer> */}
        {this.state.pagehomedetails.map((item, index) => {
          let status;
          let address_new;
          let homestreet;
          let homesubadd;
          let homeprice;
          let content;
          let bathtotal;
          if (item.BathroomsHalf) {
            bathtotal = item.BathroomsFull + item.BathroomsHalf * 0.5;
          } else {
            bathtotal = item.BathroomsFull;
          }

          if (item.PropertyType === "ResidentialLease") {
            status = `Status: ${item.PropertyType}`;
          } else if (item.MlsStatus === "Active") {
            status = `Status: Active`;
          } else if (
            item.StandardStatus === "Pending" ||
            item.MlsStatus === "Contingent"
          ) {
            status = `Status: ${item.StandardStatus}`;
          } else if (item.MlsStatus === "Sold") {
            status = `Status: ${item.MlsStatus}`;
          } else {
            status = `Status: ${item.MlsStatus}`;
          }

          if (item.UnparsedAddress) {
            // address_new = item.UnparsedAddress.split(",");
            // homestreet = address_new[2].trim();
            homesubadd =
              item.UnparsedAddress +
              ", " +
              item.City +
              ", " +
              item.StateOrProvince;

            if (item.PostalCode !== null) {
              homesubadd += ", " + item.PostalCode;
            }
          } else {
            address_new = "";
            homestreet = "";
            homesubadd = "";
          }

          if (item.MlsStatus === "Sold" && item.ClosePrice != null) {
            homeprice = `$${item.ClosePrice.toLocaleString()}`;
          } else {
            homeprice = `$${item.ListPrice.toLocaleString()}`;
          }

          let squarefeet;
          let finalpricefeet = "";
          if (item.LivingArea) {
            let priceperfeet = item.ListPrice / item.LivingArea;
            finalpricefeet = `$${parseFloat(
              priceperfeet.toFixed(0),
            ).toLocaleString()}/SqFt`;
            squarefeet = `${item.LivingArea.toLocaleString()}  SqFt`;
          } else {
            finalpricefeet = "0/SqFt";
            squarefeet = "-";
          }

          if (item.PublicRemarks) {
            content = item.PublicRemarks;
          } else {
            content = "";
          }

          let homeimages = [];
          let finalimages = [];
          let latitude = item.Latitude;
          let langitude = item.Longitude;
          let media;
          if (item.SourceId) {
            media = item.Media.split(",");

            if (media && media.length > 0) {
              {
                media.map((item2, index2) => {
                  homeimages.push(item2);
                });
              }
            }
          } else {
            media = item.Media;

            if (media && media.length > 0) {
              {
                media.map((item2, index2) => {
                  homeimages.push(item2.MediaURL);
                });
              }
            }
          }

          finalimages = homeimages;

          let npival = `NPI: ${this.state.npi}`;
          let valdata = `Value: ${this.state.value}`;
          let neighborid = `/Neighborhood/${this.state.nhfullname}`;
          let iconcolor = "#000";
          let subhedprice = "Price";
          let openhouse = true;

          if (item.MlsStatus === "Sold") {
            iconcolor = "#4288DD";
            subhedprice = "Sold Price";
            openhouse = false;
          }
          if (item.MlsStatus === "Active") {
            iconcolor = "#14A825";
          }
          if (
            item.StandardStatus === "Pending" ||
            item.MlsStatus === "Contingent"
          ) {
            iconcolor = "#3CC5A2";
            openhouse = false;
          }
          if (item.PropertyType === "ResidentialLease") {
            iconcolor = "#800080";
          }
          let sortedhistory = [];
          if (item.History && item.History.length > 0) {
            sortedhistory = item.History;
            sortedhistory.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
          }

          let lotsizeunit = item.LotSizeUnits;
          if (item.LotSizeUnits) {
            if (item.LotSizeUnits == "SquareFeet") {
              lotsizeunit = "SqFt";
            }
          }

          function truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
              return text;
            }
            return text.slice(0, maxLength) + "...";
          }

          return (
            <div className="home-wrapper">
              <Layout search={true}>
                <Grid divided stackable>
                  <Grid.Row
                    style={{ maxWidth: "1280px", margin: "0 auto" }}
                    className="detail_lisitng_top"
                  >
                    <Grid.Column
                      width={10}
                      mobile={16}
                      tablet={16}
                      computer={10}
                    >
                      <Segment padded basic>
                        <BlackTitle
                          icon={heading.icon}
                          color={iconcolor}
                          head={homestreet}
                          subhead={homesubadd}
                          desc={status}
                          floated={heading.floated}
                          className="cust_head"
                        />
                        <div className="cust_head_blk">
                          <BlackTitle
                            color="black"
                            head={squarefeet}
                            subhead={finalpricefeet}
                            floated="right"
                          />
                          <BlackTitle
                            color="black"
                            head={bathtotal ? bathtotal : "-"}
                            subhead="Baths"
                            floated="right"
                          />
                          <BlackTitle
                            color="black"
                            head={item.BedroomsTotal || "-"}
                            subhead="Beds"
                            floated="right"
                          />
                          <BlackTitle
                            color="black"
                            head={homeprice}
                            subhead={subhedprice}
                            floated="right"
                          />
                        </div>
                      </Segment>

                      <Segment basic style={{ marginBottom: "0px" }}>
                        {/* {openhouse && (
                          <LabelTag
                            as="a"
                            color="green"
                            ribbon
                            content="Open Sat, 1pm to 4pm"
                            className="open_txt_green"
                          />
                        )} */}
                        {finalimages && finalimages.length > 0 && (
                          <Gallery
                            street={true}
                            imageData={finalimages}
                            toggle={this.onDisplay}
                            openpopup={this.openpopup}
                            page="detailslisting"
                            onstreetclick={this.openStreetmodal}
                            onmapclick={this.openMapmodal}
                          />
                        )}
                        {finalimages && finalimages.length === 0 && (
                          <StreetCarousal lat={latitude} lng={langitude} />
                        )}
                        <Modal
                          isOpen={this.state.modalSlider}
                          onRequestClose={this.closeModalslider}
                          style={customStylesSlide}
                          // contentLabel="Example Modal"
                          htmlOpenClassName={"detaillisting_modal"}
                        >
                          <div className="slider_modal_btn">
                            <span
                              onClick={this.closeModalslider}
                              primary
                              style={{ marginTop: "10px" }}
                            >
                              X
                            </span>
                          </div>
                          <div className="slider_main_top">
                            <Grid className="modal_grid">
                              <GridRow>
                                <GridColumn
                                  mobile={16}
                                  tablet={16}
                                  computer={16}
                                >
                                  {finalimages && finalimages.length > 0 && (
                                    <ListingGallery
                                      imageData={finalimages}
                                      openpopup={this.openpopup}
                                      selectedItem={this.state.selectedItem}
                                      user_id={this.state.userId}
                                      is_editor={this.state.is_editor}
                                      removephoto={this.removephoto}
                                      editphotocaption={this.editphotocaption}
                                      onRatemodal={this.onRatemodal}
                                      modalhelpful={this.modalhelpful}
                                      is_static={this.state.is_static}
                                      isloaderactive={this.state.loaderactive}
                                      ismodalopen={this.state.modalSlider}
                                      islistingmodalopen={
                                        this.state.islistingmodalopen
                                      }
                                      nhid={this.neighbor_id}
                                    />
                                  )}
                                </GridColumn>
                              </GridRow>
                            </Grid>
                          </div>
                        </Modal>
                        {/* <NhGallery
                        street={true}
                        imageData={finalimages}
                        toggle={this.onDisplay}
                        openpopup={this.openpopup}
                        nhid={this.neighbor_id}
                      /> */}
                      </Segment>
                      {/* <div className="street_view_btn">
                      <button
                        class="ui primary button"
                        role="button"
                        onClick={() => this.openStreetmodal()}
                      >
                        Street View
                      </button>
                    </div> */}
                      <Modal
                        isOpen={this.state.modalMapview}
                        onRequestClose={this.closeMapmodal}
                        style={customStylesStreetModal}
                        // contentLabel="Example Modal"
                        htmlOpenClassName={"detaillisting_street_modal"}
                      >
                        <div className="slider_modal_btn">
                          <span
                            onClick={this.closeMapmodal}
                            primary
                            style={{ marginTop: "10px" }}
                          >
                            X
                          </span>
                        </div>
                        {this.state.is_load_map ? (
                          <div className="modal_map">
                            <NeighborMap
                              lat={latitude}
                              lang={langitude}
                              poly_data={
                                this.state.poly_data &&
                                this.state.poly_data.length > 0
                                  ? JSON.parse(this.state.poly_data)
                                  : ""
                              }
                              ismodal={true}
                              neighbor_id={this.state.neighbor_id}
                              npiscore={this.state.npi}
                              nhfullname={this.state.nhfullname}
                            />
                          </div>
                        ) : (
                          <Loader size="huge" inline active />
                        )}
                      </Modal>
                      <Modal
                        isOpen={this.state.modalStreetview}
                        onRequestClose={this.closeStreetmodal}
                        style={customStylesStreetModal}
                        // contentLabel="Example Modal"
                        htmlOpenClassName={"detaillisting_street_modal"}
                      >
                        <div className="slider_modal_btn">
                          <span
                            onClick={this.closeStreetmodal}
                            primary
                            style={{ marginTop: "10px" }}
                          >
                            X
                          </span>
                        </div>
                        <StreetView lat={latitude} lang={langitude} />
                      </Modal>
                      <Segment
                        basic
                        style={{
                          paddingBottom: 0,
                          paddingTop: 0,
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                      >
                        <Grid>
                          <Grid.Row
                            style={{
                              paddingBottom: 0,
                              paddingTop: 0,
                            }}
                          >
                            <Grid.Column width={12}>
                              <div className="abuot_this_hm">
                                <div>
                                  <span className="listing_details">
                                    Listed By {item.ListAgentFullName}.{" "}
                                    {item.ListAgentStateLicense &&
                                    item.ListAgentStateLicense !== ""
                                      ? "DRE# " +
                                        +"0" +
                                        item.ListAgentStateLicense +
                                        ". "
                                      : ""}
                                    {item.ListOfficeName}.{" "}
                                  </span>
                                  {item.ListAgentPreferredPhone && (
                                    <span>{item.ListAgentPreferredPhone}</span>
                                  )}
                                </div>

                                <div>
                                  <span className="listing_details">
                                    Source:{" "}
                                    {this.state.sourceType === "BAY EAST" ? (
                                      <>
                                        bridgeMLS/CCAR/Bay East AOR{" "}
                                        <img
                                          src="/static/images/bay_east_logo.jpg"
                                          className="bayeast_logo"
                                          alt="Bay East Logo"
                                        />{" "}
                                        # {item.ListingId}
                                      </>
                                    ) : this.state.sourceType ===
                                      "MLS Listing" ? (
                                      <>MLSListings, Inc.# {item.ListingId}</>
                                    ) : (
                                      <>
                                        SFAR/San Francisco, MLS #{" "}
                                        {item.ListingId}
                                      </>
                                    )}
                                  </span>
                                </div>

                                {/* <InText
                        name="Listed by"
                        size="medium"
                        //color="blue"
                        floated="left"
                      />
                      <InText
                        name={
                          item.ListAgentFullName +
                          ", " +
                          item.ListOfficeName +
                          ", " +
                          item.ListAgentStateLicense
                        }
                        size="small"
                        floated="left"
                      /> */}
                              </div>
                            </Grid.Column>
                            <Grid.Column width={4}>
                              <div className="save_home_btn">
                                {save ? (
                                  <ButtonItem
                                    as="div"
                                    labelPosition="right"
                                    //floated="right"
                                    className="theme_green btn_green"
                                    onClick={this.onSaveHome}
                                  >
                                    <ButtonItem
                                      className="theme_green btn_green"
                                      icon="check"
                                    />
                                    <Label
                                      as="a"
                                      content="Saved"
                                      basic
                                      className="theme_green btn_green"
                                      pointing="left"
                                    />
                                  </ButtonItem>
                                ) : (
                                  <ButtonItem
                                    as="div"
                                    labelPosition="right"
                                    //floated="right"
                                    onClick={this.onSaveHome}
                                    className="theme_blue btn_blue"
                                  >
                                    <ButtonItem
                                      className="btn_blue_bg"
                                      icon="heart"
                                    />
                                    <Label
                                      as="a"
                                      content="Save this Home"
                                      basic
                                      pointing="left"
                                      className="theme_blue btn_blue"
                                    />
                                  </ButtonItem>
                                )}
                              </div>
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Segment>

                      <Segment basic>
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={10}>
                              <Title name="About This Home" size="medium" />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        {content.length <= limit ? (
                          <InText name={content} size="small" />
                        ) : more ? (
                          <div
                            style={{
                              margin: "6px 7px",
                            }}
                          >
                            <span
                              className="ui small header"
                              style={{
                                color: "rgb(65, 65, 65)",
                                fontWeight: "normal",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {content}
                            </span>
                            {/* <InText name={content} size="small" /> */}
                            <span
                              className="ui blue small header"
                              style={{
                                color: "rgb(15, 20, 67)",
                                letterSpacing: "0.3px",
                                cursor: "pointer",
                              }}
                              onClick={this.onShow}
                            >
                              Show Less
                            </span>
                          </div>
                        ) : (
                          <div
                            style={{
                              margin: "6px 7px",
                            }}
                          >
                            <span
                              className="ui small header"
                              style={{
                                color: "rgb(65, 65, 65)",
                                fontWeight: "normal",
                                whiteSpace: "pre-wrap",
                              }}
                            >
                              {content.substring(0, limit)}
                            </span>
                            {/* <InText
                              name={content.substring(0, limit)}
                              size="small"
                            /> */}
                            <span
                              className="ui blue small header"
                              style={{
                                color: "rgb(15, 20, 67)",
                                letterSpacing: "0.3px",
                                cursor: "pointer",
                              }}
                              onClick={this.onShow}
                            >
                              ...Show More
                            </span>
                          </div>
                        )}
                      </Segment>

                      <Segment padded basic>
                        <Card fluid raised className="cards_listing">
                          <Grid columns="equal" padded>
                            <Grid.Column>
                              <Title name="Prop Type:" size="small" />
                              <Title name="Year Built:" size="small" />
                              <Title name="Home Size:" size="small" />
                              <Title name="Lot Size:" size="small" />
                            </Grid.Column>
                            <Grid.Column textAlign="right">
                              <InText
                                name={
                                  item.PropertySubType &&
                                  item.PropertySubType ==
                                    "SingleFamilyResidence"
                                    ? "Single Family"
                                    : item.PropertySubType
                                      ? this.state.isMobile
                                        ? truncateText(
                                            item.PropertySubType || "-",
                                            7,
                                          )
                                        : truncateText(
                                            item.PropertySubType || "-",
                                            15,
                                          )
                                      : "-"
                                }
                                size="small"
                                color="blue"
                              />
                              <InText
                                name={item.YearBuilt || "-"}
                                size="small"
                                color="blue"
                              />
                              <InText
                                name={squarefeet}
                                size="small"
                                color="blue"
                              />
                              <InText
                                name={
                                  item.LotSizeArea
                                    ? item.LotSizeArea.toLocaleString() +
                                      " " +
                                      lotsizeunit
                                    : "-"
                                }
                                size="small"
                                color="blue"
                              />
                            </Grid.Column>
                            <Grid.Column>
                              <Title
                                name="Neighborhood:"
                                size="small"
                                className="margin_mls"
                              />
                              <Title
                                name="MLS #:"
                                size="small"
                                className="margin_mls"
                              />
                              <Title
                                name="Days on Houseberry:"
                                size="small"
                                className="margin_mls"
                              />
                              <Title
                                name="HOA:"
                                size="small"
                                className="margin_mls"
                              />
                            </Grid.Column>
                            <Grid.Column textAlign="right">
                              <InText
                                name={
                                  this.state.neighborname
                                    ? this.state.isMobile
                                      ? truncateText(this.state.neighborname, 7)
                                      : truncateText(
                                          this.state.neighborname,
                                          15,
                                        )
                                    : "-"
                                }
                                size="small"
                                color="blue"
                              />
                              <InText
                                name={
                                  item.ListingId
                                    ? this.state.isMobile
                                      ? truncateText(item.ListingId, 7)
                                      : truncateText(item.ListingId, 15)
                                    : "-"
                                }
                                size="small"
                                color="blue"
                                className="lot-size-data_listing"
                              />
                              <InText
                                name={
                                  item.DaysOnHouseBerry !== null
                                    ? item.DaysOnHouseBerry
                                    : "-"
                                }
                                size="small"
                                color="blue"
                              />
                              <InText
                                name={
                                  item.AssociationFee &&
                                  item.AssociationFee > 0 &&
                                  item.AssociationFee !== null
                                    ? "$" + item.AssociationFee
                                    : "-"
                                }
                                size="small"
                                color="blue"
                              />
                            </Grid.Column>
                          </Grid>
                        </Card>
                      </Segment>
                      <Segment basic>
                        <Divider />
                        <Title name="Property History" size="medium" />
                        {sortedhistory && sortedhistory.length > 0 ? (
                          <TableItem
                            className="unstackable custom_table"
                            color="blue"
                            headers={thead}
                            items={sortedhistory}
                          />
                        ) : (
                          <p>No History Found</p>
                        )}
                      </Segment>
                      <Segment basic id="school_serve">
                        {/* <Divider /> */}
                        <Title
                          name="Schools serving this Neighborhood"
                          size="medium"
                        />
                        <div className="school_tbl">
                          {this.state.schoolistingarr &&
                          this.state.schoolistingarr.length > 0 ? (
                            <div className="school_tbl_main">
                              <TableItem
                                className="unstackable custom_table"
                                color="blue"
                                headers={shead}
                                items={this.state.schoolistingarr}
                              />
                            </div>
                          ) : (
                            this.state.schoolistingarr.length === 0 &&
                            this.state.schoolloader && (
                              <p style={{ textAlign: "Center" }}>
                                {this.state.schoolloadertxt}
                              </p>
                            )
                          )}
                          {this.state.schoolistingarr &&
                            this.state.schoolistingarr.length > 0 &&
                            !this.state.isMobile && (
                              <div className="school_tbl_sub_txt">
                                <div className="school_tbl_sub_txt_left">
                                  <p>Click links for school listing</p>
                                  <p>info at GreatSchools.org</p>
                                  {/* <p className="school_tbl_sub_logo">
                                      <a
                                        href="https://www.greatschools.org"
                                        target="_blank"
                                        rel="nofollow"
                                        title="Great School.org"
                                      >
                                        <img
                                          width="80px"
                                          height="32px"
                                          loading="lazy"
                                          src={
                                            process.env.NEXT_PUBLIC_CDN_ID +
                                            "static/images/great-school.png"
                                          }
                                          title="GreatSchool"
                                          alt="Great School.org"
                                        />
                                      </a>
                                    </p> */}
                                </div>
                                <div className="school_tbl_sub_txt_right">
                                  <p>Houseberry School Score Data</p>
                                  <p>from CA Dept. of Education</p>
                                  {/* <p className="school_tbl_sub_logo">
                                      <a
                                        href="https://www.houseberry.com"
                                        rel="nofollow"
                                        title="Houseberry"
                                      >
                                        <img
                                          width="130px"
                                          src={
                                            process.env.NEXT_PUBLIC_CDN_ID +
                                            "static/images/houseberry-mobile.svg"
                                          }
                                          title="houseberry"
                                          alt="houseberry"
                                        />
                                      </a>
                                    </p> */}
                                </div>
                              </div>
                            )}
                          {/* {this.schoollisting && this.schoollisting.length > 0 && (
                            <div className="great-school">
                              <p className="data_provided">
                                Data Provided by{" "}
                                <a
                                  href="https://www.greatschools.org"
                                  target="_blank"
                                  rel="nofollow"
                                  title="Great School.org"
                                >
                                  GreatSchools.org{" "}
                                </a>
                                &copy; 2024 All Rights Reserved
                              </p>
                              <a
                                href="https://www.greatschools.org"
                                target="_blank"
                                rel="nofollow"
                                title="Great School.org"
                              >
                                <img
                                  width="95px"
                                  src={
                                    process.env.NEXT_PUBLIC_CDN_ID +
                                    "static/images/great-school.png"
                                  }
                                  title="GreatSchool"
                                  alt="Great School.org"
                                />
                              </a>
                            </div>
                          )} */}
                          <p className="school_disclaimer">
                            Houseberry recommends using these scores as only a
                            starting point, and conducting your own
                            investigation into what schools fit best for your
                            preferences. School boundaries are not guaranteed
                            and may change. It is important to contact the
                            appropriate school district to confirm enrollment
                            eligibility before making any decision to move to a
                            neighborhood.
                          </p>
                        </div>
                      </Segment>
                      {/* <Segment basic>
                        <Title name="Schools" size="medium" />
                        {this.state.schoolistingarr &&
                        this.state.schoolistingarr.length > 0 ? (
                          <TableItem
                            color="blue"
                            headers={shead}
                            items={this.state.schoolistingarr}
                          />
                        ) : (
                          <p style={{ textAlign: "Center" }}>No school Found</p>
                        )}
                      </Segment> */}
                      <Segment
                        basic
                        style={{ paddingBottom: "0px", marginBottom: "0px" }}
                        className="amenities_segment"
                        id="amenities_nh"
                      >
                        <Divider />
                        <Title name="Neighborhood Amenities" size="medium" />
                        <div className="amenities_sec">
                          <AmenitiesItem
                            className="amenities_scores"
                            amenitiesgrid={this.state.amenities_factor}
                          />
                        </div>
                        <div className="overall_amenities">
                          <p>
                            Overall Amenities score: {this.state.amenitiesscore}{" "}
                            {this.state.amenitiesFlag && <sup>(1)</sup>}
                          </p>
                          {this.state.amenitiesFlag && (
                            <span>(1)Incomplete Data</span>
                          )}
                        </div>
                      </Segment>
                      <Divider />
                    </Grid.Column>
                    <Grid.Column
                      width={6}
                      mobile={16}
                      tablet={16}
                      computer={6}
                      className="details_lisitng_right"
                    >
                      <Segment basic className="common_pad_ui_mobile">
                        <Title name="Neighborhood Summary" size="medium" />
                        {/* <ItemData
                  size="small"
                  source={this.state.neighborimage && this.state.neighborimage ? this.state.neighborimage:"/static/images/defaultnhmap.jpg"}
                  head={this.state.neighborname}
                  subhead={npival}
                  desc={valdata}
                  extra="Best park in the
              peninsula. Most wonderful neighbors"
                  href={neighborid}
                /> */}
                        <Item.Group className={"doubling"}>
                          <Item className="detailsListing_data">
                            <Link
                              href={neighborid}
                              style={{ cursor: "pointer", marginRight: 20 }}
                              target="_blank"
                            >
                              {/* <a
                                style={{ cursor: "pointer", marginRight: 20 }}
                                target="_blank"
                              > */}
                              <Item.Image
                                src={
                                  this.state.neighborimage &&
                                  this.state.neighborimage
                                    ? this.state.neighborimage
                                    : process.env.NEXT_PUBLIC_CDN_ID +
                                      "static/images/defaultnhmap.jpg"
                                }
                                size="small"
                              />
                              {/* </a> */}
                            </Link>
                            <Item.Content
                              verticalAlign="top"
                              className="right_content_top map_right_blk"
                            >
                              <Link href={neighborid} target="_blank">
                                {/* <a target="_blank"> */}
                                <Item.Header
                                  content={this.state.neighborname}
                                  className="mob_title_mar"
                                  style={{
                                    cursor: "pointer",
                                    color: "#4183c4",
                                    fontWeight: "bold",
                                    fontSize: 17,
                                    marginBottom: "3px",
                                  }}
                                />
                                {/* </a> */}
                              </Link>
                              <div>
                                {this.state.is_ratedisplay && (
                                  <div className="rating_section rating_Details_listing">
                                    {fullcount > 0 &&
                                      [...Array(fullcount)].map(
                                        (item, index) => {
                                          return (
                                            <span>
                                              <img
                                                src={
                                                  process.env
                                                    .NEXT_PUBLIC_CDN_ID +
                                                  "static/images/rating_full.png"
                                                }
                                                className="rating_img"
                                                title="rating"
                                                alt="Home Rating"
                                              />
                                            </span>
                                          );
                                        },
                                      )}
                                    {quatercount > 0 &&
                                      [...Array(quatercount)].map(
                                        (item, index) => {
                                          return (
                                            <span>
                                              <img
                                                src={
                                                  process.env
                                                    .NEXT_PUBLIC_CDN_ID +
                                                  "static/images/rating_quater.png"
                                                }
                                                className="rating_img"
                                                title="rating"
                                                alt="Home Rating"
                                              />
                                            </span>
                                          );
                                        },
                                      )}
                                    {halfcount > 0 &&
                                      [...Array(halfcount)].map(
                                        (item, index) => {
                                          return (
                                            <span>
                                              <img
                                                src={
                                                  process.env
                                                    .NEXT_PUBLIC_CDN_ID +
                                                  "static/images/rating_half.png"
                                                }
                                                className="rating_img"
                                                title="rating"
                                                alt="Home Rating"
                                              />
                                            </span>
                                          );
                                        },
                                      )}
                                    {quaterhalf > 0 &&
                                      [...Array(quaterhalf)].map(
                                        (item, index) => {
                                          return (
                                            <span>
                                              <img
                                                src={
                                                  process.env
                                                    .NEXT_PUBLIC_CDN_ID +
                                                  "static/images/rating_quater_half.png"
                                                }
                                                className="rating_img"
                                                title="rating"
                                                alt="Home Rating"
                                              />
                                            </span>
                                          );
                                        },
                                      )}
                                    {emptycount > 0 &&
                                      [...Array(emptycount)].map(
                                        (item, index) => {
                                          return (
                                            <span>
                                              <img
                                                src={
                                                  process.env
                                                    .NEXT_PUBLIC_CDN_ID +
                                                  "static/images/rating_empty.png"
                                                }
                                                className="rating_img"
                                                title="rating"
                                                alt="Home Rating"
                                              />
                                            </span>
                                          );
                                        },
                                      )}
                                    <div className="rating_cnt">
                                      <span className="score_rating">
                                        {`${Number(
                                          ((this.state.npi / 100) * 5).toFixed(
                                            2,
                                          ),
                                        ).toFixed(1)} `}
                                        /5
                                      </span>
                                    </div>
                                  </div>
                                )}{" "}
                                <div className="per_rating">
                                  {this.state.personal != "" && (
                                    <InText
                                      name={
                                        "Personal Score: " +
                                        this.state.personal +
                                        "/5"
                                      }
                                      className="personal_txt_lft"
                                    />
                                  )}
                                </div>
                                {this.state.neighbordatas &&
                                  this.state.neighbordatas.length > 0 && (
                                    <div className="npi_rating">
                                      Ranked
                                      <a
                                        href={`/Nhranking/best-overall/${this.state.neighbordatas[0].cityfullname}`}
                                        target="_blank"
                                      >
                                        #{this.state.npirank}
                                      </a>{" "}
                                      in{" "}
                                      <a
                                        href={`/City/${this.state.neighbordatas[0].cityfullname}`}
                                        target="_blank"
                                        title={
                                          this.state.neighbordatas[0]
                                            .census_name
                                        }
                                      >
                                        {
                                          this.state.neighbordatas[0]
                                            .census_name
                                        }
                                        {`, ${this.state.neighbordatas[0].label
                                          .split(",")
                                          .pop()}`}
                                      </a>
                                    </div>
                                  )}
                              </div>

                              {/* <p className="nhpannel_npi"><span className="select_score">Overall</span>: {Math.round(this.state.npi)}</p>
                                <p className="nhpannel_npi"><span className="select_score">Value</span>: {Math.round(this.state.value)}</p>
                                <p className="nhpannel_npi"><span className="select_score">School</span>: {Math.round(this.state.school)}</p>
                                <p className="nhpannel_npi"><span className="select_score">Safety</span>: {Math.round(this.state.safety)}</p>
                                <p className="nhpannel_npi"><span className="select_score">Walkability</span>: {Math.round(this.state.walkability)}</p>
                                <p className="nhpannel_npi"><span className="select_score">Town</span>: -</p>
                                <p className="nhpannel_npi"><span className="select_score">Curb</span>: -</p>
                                <p className="nhpannel_npi"><span className="select_score">Community</span>: -</p>
                                <p className="nhpannel_npi"><span className="select_score">Personal</span>: {Math.round(this.state.personal*10)}</p>
                                <p className="nhpannel_desc" style={{marginTop:"5px"}}>{this.state.final_summary}</p> */}
                              {/* <div className="description">
                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "NPI is overall neighborhood performance score"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">
                                      Overall
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {(
                                        (Math.round(this.state.npi) / 100) *
                                        5
                                      ).toFixed(1)}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "Personalize search based on preferences"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">
                                      Personal
                                    </span>{" "}
                                    : <span>{this.state.personal}</span>
                                  </p>
                                }
                              />

                              <Popup
                                className="right_content_top_popup"
                                content={"Neighborhood school score"}
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">School</span>{" "}
                                    :{" "}
                                    <span>
                                      {Number(
                                        ((this.state.school / 10) * 5).toFixed(
                                          2
                                        )
                                      ).toFixed(1)}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={"Neighborhood safety score"}
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">Safety</span>{" "}
                                    :{" "}
                                    <span>
                                      {(
                                        (Math.round(this.state.safety) / 10) *
                                        5
                                      ).toFixed(1)}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={"Neighborhood safety score"}
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">
                                      Amenities
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {this.state.amenitiesscore > 0
                                        ? this.state.amenitiesscore
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={"Neighborhood walkability score"}
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi sub_amenities">
                                    <span className="select_score">
                                      Near Merchants
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {this.state.townctrscore > 0
                                        ? this.state.townctrscore
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "Curb Appeal of its streets and houses"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi sub_amenities">
                                    <span className="select_score">
                                      Public Spaces
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {this.state.publicscore > 0
                                        ? this.state.publicscore
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "Curb Appeal of its streets and houses"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi sub_amenities">
                                    <span className="select_score">
                                      Curb Appeal
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {" "}
                                      {this.state.curbappealscore > 0
                                        ? this.state.curbappealscore
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "Quality of nearby town center & local stores"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">Price</span>{" "}
                                    :{" "}
                                    <span>
                                      {this.state.nhprice > 0
                                        ? "$" +
                                          parseFloat(
                                            this.state.nhprice
                                          ).toLocaleString()
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />


                              <Popup
                                className="right_content_top_popup"
                                content={
                                  "Neighborhood value based on overall score & price"
                                }
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">Value</span>{" "}
                                    :{" "}
                                    <span className="listing_val">
                                      {this.state.value === 0
                                        ? "-"
                                        : "$" +
                                          parseInt(this.state.value)
                                            .toLocaleString()
                                            .replace("-", "")}
                                    </span>
                                    {this.state.value > 0 ? (
                                      <span className="overval">
                                        Overvalued
                                      </span>
                                    ) : this.state.value < 0 ? (
                                      <span className="underval">
                                        Undervalued
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                }
                              />
                              <Popup
                                className="right_content_top_popup"
                                content={"Appreciation"}
                                size="mini"
                                position="right center"
                                trigger={
                                  <p className="nhpannel_npi">
                                    <span className="select_score">
                                      Appreciation
                                    </span>{" "}
                                    :{" "}
                                    <span>
                                      {" "}
                                      {this.state.appreciation != ""
                                        ? this.state.appreciation + "%"
                                        : "-"}
                                    </span>
                                  </p>
                                }
                              />
                            </div>
                            <p
                              className="nhpannel_desc"
                              style={{ marginTop: "5px" }}
                            >
                              {this.state.final_summary}
                            </p> */}
                            </Item.Content>
                          </Item>
                        </Item.Group>
                      </Segment>
                      {/* <Segment basic>
                      {!isMobile && (
                        <>
                          <Title name="Neighborhood Map" size="medium" />
                          <Divider hidden />
                          {this.state.poly_data &&
                            this.state.poly_data.length > 0 && (
                              <Newmap
                                lat={latitude}
                                lang={langitude}
                                poly_data={
                                  this.state.poly_data &&
                                  this.state.poly_data.length > 0
                                    ? JSON.parse(this.state.poly_data)
                                    : ""
                                }
                                npiscore={this.state.npi}
                                neighbor_id={this.state.neighbor_id}
                              />
                            )}
                        </>
                      )}
                    </Segment> */}
                      <Segment basic>
                        <div className="factor_section details_listing_factors">
                          <Grid>
                            <Grid.Row className="img_deatils">
                              <Grid.Column
                                mobile={16}
                                tablet={16}
                                computer={16}
                              >
                                <p className="factor_titile ">
                                  Neighborhood Factors
                                </p>
                                <IconsGrid
                                  gridData={this.state.factors}
                                  onscoreclick={this.handlescoreclick}
                                />
                                {/* {this.state.amenitiesFlag && (
                              <p className="nh_level_txt">(1)Incomplete data</p>
                            )} */}
                              </Grid.Column>

                              <Grid.Column
                                mobile={16}
                                tablet={16}
                                computer={16}
                              >
                                <p className="factor_titile_market_cond">
                                  Market Conditions
                                </p>
                                <IconsGrid
                                  gridData={this.state.factors_right}
                                />
                                {(this.state.appreciationCityFlag === true ||
                                  this.state.medianPriceDomCityFlag ===
                                    true) && (
                                  <p className="city_level_txt">
                                    (2)City data used
                                  </p>
                                )}
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </div>
                      </Segment>
                      <Segment basic>
                        <div className="expert_contact_section">
                          <p>Looking to Buy or Sell?</p>
                          <Button primary fluid onClick={this.openAgentPopup}>
                            Contact a Neighborhood Expert
                          </Button>

                          <AgentContact
                            open={this.state.showAgentPopup}
                            onClose={this.closeAgentPopup}
                            neighborhoodname={
                              this.state.neighborname && this.state.neighborname
                            }
                          />
                        </div>
                      </Segment>
                      <Segment
                        basic
                        className="common_pad_ui_mobile_1 map_segment"
                      >
                        <Title name="Neighborhood Map" size="medium" />

                        {this.state.is_load_map && (
                          <NeighborMap
                            lat={latitude}
                            lang={langitude}
                            poly_data={
                              this.state.poly_data &&
                              this.state.poly_data.length > 0
                                ? JSON.parse(this.state.poly_data)
                                : ""
                            }
                            homes={
                              this.state.home_marker_data &&
                              this.state.home_marker_data.length > 0
                                ? this.state.home_marker_data
                                : []
                            }
                            neighbor_id={this.state.neighbor_id}
                            npiscore={this.state.npi}
                            nhfullname={this.state.nhfullname}
                          />
                        )}
                      </Segment>

                      {/* {this.state.agent_data.length === 0 && (
                        <>
                          <Segment basic className="common_pad_ui_mobile">
                            <Title
                              name="Top Agents for this Neighborhood"
                              size="medium"
                            />
                            <p className="agent_sub_title">
                              (Based On Neighborhood Points)
                            </p>
                            <div className="no_agent_listing">
                              <Segment basic>
                                <span>
                                  Become a featured Agent by writing a{" "}
                                  <a onClick={this.onReview}>Review</a> for this
                                  Neighborhood.
                                </span>
                              </Segment>
                            </div>
                          </Segment>
                        </>
                      )} */}

                      {/* {this.state.agent_data &&
                        this.state.agent_data.length > 0 && (
                          <Segment basic>
                            <Title
                              name="Top Agents for this Neighborhood"
                              size="medium"
                            />

                            {this.state.agent_data.length > 0 && (
                              <ItemsList
                                id="agents"
                                itemData={
                                  this.state.agent_data.length > 0
                                    ? this.state.agent_data
                                    : []
                                }
                                href="/ProfileRealtor"
                                prevagent={this.togglePrev}
                                activeagent={activePage1}
                              />
                            )}
                          </Segment>
                        )} */}
                      <Segment
                        basic
                        className="common_pad_ui_mobile_1 home_sales_nh"
                      >
                        {this.state.home_data &&
                          this.state.home_data.length > 0 && (
                            <Title
                              name="Homes for Sale in this Neighborhood"
                              size="medium"
                            />
                          )}
                        <div className="sale_home_section">
                          <CardList
                            id="sale"
                            cardData={cardData}
                            homedata={
                              this.state.home_data &&
                              this.state.home_data.length > 0
                                ? this.state.home_data
                                : []
                            }
                            save={this.onSaveHeart}
                            heart={heart}
                            href="/DetailsListing"
                            prev={this.togglePrev}
                            active={activePage2}
                            getData={this.onGet}
                            checkIfImageExistshome={(e) =>
                              this.checkIfImageExists(e)
                            }
                          />
                        </div>
                      </Segment>

                      <LoginModal
                        open={lmodal}
                        change={this.feildChange}
                        submit={this.modalSubmit}
                        next={this.nextModal}
                        iconclick={this.closeModal}
                        email_err_status={this.state.email_err_status}
                        email_err_msg={this.state.email_err_msg}
                        pwd_err_status={this.state.pwd_err_status}
                        pwd_err_msg={this.state.pwd_err_msg}
                        isSaving={this.state.isSaving}
                      />
                      <SignupModal
                        open={smodal}
                        change={this.feildChange}
                        submit={this.modalSubmit}
                        next={this.nextModal}
                        iconclick={this.closeModal}
                        isSaving={this.state.isSaving}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Segment>
                  <div className="mt-30">
                    <LandingFooter />
                  </div>
                </Segment>
              </Layout>
              <FeedbackForm />
            </div>
          );
        })}
      </div>
    );
  }
}

export default Listing;

export async function getStaticProps() {
  return {
    props: {
      query: {},
    },
  };
}
